import { components } from "@certn/legacy-api/generated-schemas/people";

import { ValidationRuleType } from "./types";

export function requireXEmploymentReferencesRule(
  rule: components["schemas"]["RequireEmploymentReferencesRule"]
): ValidationRuleType {
  return {
    rule,
    isValid: (
      employment_references: components["schemas"]["EmploymentReferencesCheckFieldValue"]
    ) => {
      const references =
        employment_references?.references ?? employment_references;

      return references?.length >= rule.value;
    },
  };
}
